// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"CreatorInfo_textContainer__hhgCs","underline":"CreatorInfo_underline__s5gxp","avatar":"CreatorInfo_avatar__lFH2O"};